export default {
    meta: {
        title: '商机详情',
        isShowNav: false,
        isShowHeader: false,
    },
};
